import { computed, onMounted, onUnmounted, ref, unref, watch } from '@vue/composition-api'
import { useEventBus, whenever } from '@vueuse/core'
import { getSelectionId } from '@ms/components/betslip/core/save.js'
import { isBetBuilderSelection, getBetBuilderSelectionId, isInBetBuilderSelections, isSelectedOutcome } from '@ms/stores/betslip/func'
import useTimeDispear from 'composables/useTimeDispear.js'

// 赔率变化持续时间
const duration = 5000

export default function useOutcome(props, selectionList) {
  const active = ref(false)

  const selectionId = computed(() => {
    if (!props.event || !props.market || !props.outcome) return ''
    return getSelectionId(props.event.eventId, props.market.id, props.outcome.id, props.market.specifiers)
  })

  const onRemoveBetslipSelection = (selection) => {
    if (!selection) {
      active.value = false
    } else {
      const { id } = selection
      if (!unref(active)) return
      if (isBetBuilderSelection(selection)) {
        const curSelectionId = getBetBuilderSelectionId(props.event.eventId)
        if (id !== curSelectionId) return
        const { event, market, outcome } = props
        if (props.market.comboType && isInBetBuilderSelections(selection, { event, market, outcome })) {
          active.value = false
        }
      } else {
        if (id !== unref(selectionId)) return
        if (!props.market.comboType) {
          active.value = false
        }
      }
    }
  }

  const onAddBetslipSelection = (selection) => {
    const { id } = selection
    if (unref(active) || !props.event) return

    if (isBetBuilderSelection(selection)) {
      const curSelectionId = getBetBuilderSelectionId(props.event.eventId)
      if (id !== curSelectionId) return
      const { event, market, outcome } = props
      if (isInBetBuilderSelections(selection, { event, market, outcome })) {
        active.value = true
      }
    } else if (id === unref(selectionId)) {
      active.value = true
    }
  }

  // odds 变化状态, 0 表示不变, -1 表示 down, 1 表示 up
  const status = ref(0)
  const updateStatus = (val = 0) => {
    status.value = val
  }

  const isDisabled = computed(() => {
    const { outcome } = props
    if (!outcome) return true
    return props.disabled || !outcome || !(outcome.isActive === 1 && props.market.status === 0)
  })
  const isUp = computed(() => !isDisabled.value && status.value === 1)
  const isDown = computed(() => !isDisabled.value && status.value === -1)

  let readyToDisappear = useTimeDispear(updateStatus, duration)

  // 监听并修改 odds 变化状态
  watch(
    () => props.outcome && props.outcome.odds,
    (val, oldVal) => {
      val = +val
      oldVal = +oldVal
      if (val > 0 && oldVal > 0) {
        if (val > oldVal) {
          updateStatus(1)
          readyToDisappear()
        } else if (val < oldVal) {
          updateStatus(-1)
          readyToDisappear()
        }
      }
    }
  )

  whenever(isDisabled, () => {
    updateStatus(0)
  })

  useEventBus('add-betslip-selection').on(onAddBetslipSelection)
  useEventBus('remove-betslip-selection').on(onRemoveBetslipSelection)

  onMounted(() => {
    const { event, market, outcome } = props
    active.value = isSelectedOutcome(unref(selectionList), { event, market, outcome })
  })

  onUnmounted(() => {
    readyToDisappear = null
  })

  return {
    active,
    selectionId,
    isDisabled,
    isUp,
    isDown,
    updateStatus
  }
}
